<template>
	<!-- <div class="watch-options"> -->
		<!-- <button @click="openModal" class="gear">
			<svgicon name="settings" :fill="false"/>
		</button> -->
		<modal-box v-if="modalBox.open" @close="closeModal" :header="$t('headers.general.options')" :subHeader="$t('headers.general.patient')">
			<div slot="buttons">
				<button @click="selectTab('devices')" :class="cssClass('devices')">{{ $t('buttons.general.devices') }}</button>
				<button @click="selectTab('configs')" :class="cssClass('configs')">{{ $t('buttons.general.configs') }}</button>
				<!-- <button @click="selectTab('delete')" :class="cssClass('delete')">{{ $t('buttons.general.delete') }}</button> -->
			</div>
			<watch-options-devices v-if="isSelected('devices')" :user_uid="user_uid" :watch_id="watch_id"/>
			<watch-options-configs v-if="isSelected('configs')" :user_uid="user_uid" :watch_id="watch_id"/>
			<!-- <watch-options-delete v-if="isSelected('delete')" :user_uid="user_uid" :watch_id="watch_id"/> -->
		</modal-box>
	<!-- </div> -->
</template>

<script>
import WatchOptionsDevices from './WatchOptionsDevices'
import WatchOptionsConfigs from './WatchOptionsConfigs'
import WatchOptionsDelete from './WatchOptionsDelete'
export default {
	name: 'watch-options',
	components: {
		WatchOptionsDevices,
		WatchOptionsConfigs,
		WatchOptionsDelete
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			modalBox: {
				open: false
			},
			selectedTab: 'devices'
		}
	},
	methods: {
		selectTab (tabName) {
			this.selectedTab = tabName
		},
		isSelected (tabName) {
			return this.selectedTab === tabName
		},
		cssClass (tabName) {
			return this.isSelected(tabName) ? 'active' : ''
		},
		openModal () {
			this.modalBox.open = true
		},
		closeModal () {
			this.modalBox.open = false
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/options/WatchOptions.vue